<template>
  <BaseModal
    :title="$t('Profile settings')"
    :tabs="USER_MODAL_TABS"
    :current-tab-id="tab"
    @change-tab="changeTab"
  >
    <UserSettingsGeneralForm v-if="tab === 1" :user="user" />
    <UserSettingsAccountForm v-if="tab === 2" />
  </BaseModal>
</template>

<script>
  import UserSettingsGeneralForm from '@/containers/top-menu/header/profile-settings/GeneralForm';
  import UserSettingsAccountForm from '@/containers/top-menu/header/profile-settings/AccountForm';
  import { mapState } from 'vuex';
  import BaseModal from '@/components/ui/BaseModal';

  export default {
    name: 'UserSettingsModal',
    components: { BaseModal, UserSettingsAccountForm, UserSettingsGeneralForm },
    data() {
      return {
        tab: 1,
      };
    },
    computed: {
      ...mapState('auth', ['user']),
      USER_MODAL_TABS() {
        return [
          { id: 1, text: this.$t('General') },
          { id: 2, text: this.$t('Security') },
        ];
      },
    },
    methods: {
      changeTab(id) {
        this.tab = id;
      },
    },
  };
</script>
